module.exports = __webpack_public_path__ + "static/media/key-white.85048c1a.svg";